module.exports = __webpack_public_path__ + "static/media/icons-full-screen.5662fe0c.svg";